export const experienceData = [
  {
    id: 1,
    role: "Associate Software Engineer",
    company: "Bosch Global Software Technologies",
    duration: "Jan 2024 - Present",
    description: [
      "Developed Frontend for Internal Job Posting Website using React JS.",
      "Optimized the website to be user friendly and responsive on all devices.",
      "Worked on Manual and Automation Testing for Migration Project for SharePoint OnPrem to SharePoint 2019.",
      "Optimized Selenium Automation Framework (C#) with better structure to increase Maintainability of project.",
      "Created an Alternative Automation Framework using Playwright (Typescript) for Access Management Project which will be extended to other projects.",
      "Implemented AI Plugins such as ZeroStep AI to further help Test Cases in self-healing, thus making code writing easy and readable."
    ]
  }
];
